// NOTE: these are injected at build time by Vue CLI. If missing, we fallback to safe defaults
// to avoid runtime crashes like fetch("undefined/...").

// Track API base (projects/api track routes). Typical value: https://api.rx2go.ai/v1/track
// NOTE: in our Laravel API routes are grouped under "/v1" (no extra "/api" prefix).
export const apiUrl = process.env.VUE_APP_API_TRACK_URL || '/v1/track'

// "Common" API base (various track endpoints). Keep empty to use same-origin by default.
export const commUrl = process.env.VUE_APP_API_COMMON_URL || ''

// Dashboard base (legacy endpoints used by track, e.g. /ajax/PullCommon.php).
// Keep empty to use same-origin by default.
export const dashUrl = process.env.VUE_APP_API_DASHBOARD_URL || ''
export const isRx4Route = process.env.VUE_APP_IS_RX4ROUTE === 'true'
export const trackingAuthEnabled = process.env.VUE_APP_TRACKING_AUTH_ENABLED === 'true'

export const phones = {
  2: { // NY
    formatted: '+1 (929) 744-1114',
    trimmed: '+19297441114',
  },
  3: { // LA
    formatted: '+1 (747) 261-1444',
    trimmed: '+17472611444',
  },
}
